module.exports = __webpack_public_path__ + "static/carousel-03@2x-8021ca5507de3df34606d03e5e93fb36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-03@2x.jpg
// module id = 2520
// module chunks = 168707334958949